module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "zk-select-dropdown",
    class: {
      'is-multiple': _vm.$parent.multiple
    },
    style: ({
      minWidth: _vm.minWidth
    })
  }, [_vm._t("default")], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/.11.1.4@vue-loader/lib/template-compiler.js?{"id":"data-v-0ccbec8f"}!./~/.11.1.4@vue-loader/lib/selector.js?type=template&index=0!./src/packages/select/src/select-dropdown.vue
// module id = 233
// module chunks = 0